module.exports = __webpack_public_path__ + "static/img/teach2.487578d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upiTeaching/teach2.png
// module id = PH3H
// module chunks = 0